import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RelatorioAprovacaoConfig } from 'helper/Relatorios/Aprovacao/config';
import { AprovacaoParams } from 'types/Relatorios/Aprovacao';

/**
 * Params da edição aplicada (`informe`, `data_rodada` ISO e cenário/modo) a partir
 * do slice do informe. O selector de data devolve objeto novo a cada chamada:
 * `shallowEqual` + `useMemo` sobre os primitivos mantêm a referência estável
 * (evita refetch RTK Query).
 */
export default function useAprovacaoParams(config: RelatorioAprovacaoConfig): AprovacaoParams {
  const { ano, mes, dia } = useSelector(config.selectDataAnalisada, shallowEqual);
  const variante = useSelector(config.selectVariante);
  const { informe, variante: { campo } } = config;

  return useMemo(() => {
    const mm = String(mes).padStart(2, '0');
    const dd = String(dia).padStart(2, '0');
    const dataRodada = `${ano}-${mm}-${dd}`;
    return campo === 'modo'
      ? { informe, data_rodada: dataRodada, modo: variante }
      : { informe, data_rodada: dataRodada, cenario: variante };
  }, [informe, campo, ano, mes, dia, variante]);
}
